import {createSlice} from '@reduxjs/toolkit';
import {httpPost, httpGet} from '../../../../util/Rest';
import {CLIENT_MAINTENANCE} from '../../../../constants/MicroServiceConstants';
import {
  LIST_FEE_TABLE,
  RATE_TABLE,
  MONITOR_FEE_TABLE,
  NET_OR_GROSS,
  BILL_COURT_COST,
} from '../../../../constants/Lookup';

const initialData = {
  billingData: {},
  billingStatus: null,
  dropDownData: {},
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'billing',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchBillingData: (state, action) => {
      state.billingData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postBillingData: (state, action) => {
      state.billingStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    resetBillingStatus: (state) => {
      state.billingStatus = null;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    resetMsg: (state, action) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

// Actions

const {
  fetchStart,
  fetchDropDownData,
  fetchError,
  postBillingData,
  fetchBillingData,
  resetBillingStatus,
  resetMsg,
} = slice.actions;

export const fetchBilling = (clientNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    Promise.all([
      httpPost('lookup/find/all/lookup', {
        typeCode: [LIST_FEE_TABLE, RATE_TABLE, MONITOR_FEE_TABLE, BILL_COURT_COST, NET_OR_GROSS],
      }),
      httpGet(`${CLIENT_MAINTENANCE}/find/clientbilling/${clientNumber}`),
    ])
      .then((data) => {
        const lookUpApiData = data && data[0] ? data[0] : null;
        const billingData = data && data[1] ? data[1] : null;
        if (lookUpApiData && lookUpApiData.status && lookUpApiData.status === 200) {
          dispatch(fetchDropDownData(lookUpApiData.data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
        if (billingData?.status && billingData.status === 200) {
          dispatch(fetchBillingData(billingData.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const postBilling = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${CLIENT_MAINTENANCE}/save/clientbilling`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postBillingData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const resetMessage = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
export const resetStatus = () => {
  return (dispatch) => {
    dispatch(resetBillingStatus());
  };
};
